import graphql__c92fcea6e9373021b368 from "./__generated__/AnonymousUserAuthMutation.graphql.js";import { commitMutation, graphql } from "react-relay";
import mapValues from "lodash/mapValues";
import omit from "lodash/omit";
import pick from "lodash/pick";

import appRelayEnvironment from "../config/AppRelayEnvironment";
import normalizeFieldValue from "../helpers/normalizeFieldValue";
import serializeAnswers from "../helpers/serializeAnswers";

const staticSignUpFields = ["name", "email", "emailConsent", "emailTrackingConsent"];

const mutation = graphql__c92fcea6e9373021b368;

function anonymousUserAuth(form, contributionId, onCompleted) {
  // Use simple value mapping processing on the static fields that we handle
  // manually in the sign up form, but extract the dynamic answers created
  // through the admin panel and put them in the `answers` key to be processed
  // as such by the mutation backend
  const staticFields = pick(form.fields, staticSignUpFields);
  const variables = mapValues(staticFields, normalizeFieldValue);

  variables.answers = serializeAnswers({
    ...form,
    fields: omit(form.fields, staticSignUpFields),
    schema: omit(form.schema, staticSignUpFields)
  });

  // Set an optionally provided contributionId if the authentication was run in the
  // context of the submission of a contribution. This allows for storing the fact that
  // the anonymous user authentication was already run for the current viewer and
  // contribution to avoid prompting the viewer to authenticate again on the next form
  // pages.
  variables.contributionId = contributionId;

  return commitMutation(appRelayEnvironment, {
    mutation,
    variables,
    onCompleted,
    onError: error => console.error(error)
  });
}

export { anonymousUserAuth };
